import { clsx, type ClassValue } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

// tailwind-merge must know the custom token names, otherwise e.g. `text-meta` and `text-text-primary`
// would be treated as conflicting (both start with `text-`).
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      color: [
        'transparent', 'current',
        'surface-canvas', 'surface-default', 'surface-subtle', 'surface-overlay',
        'text-primary', 'text-secondary', 'text-on-primary',
        'brand-primary', 'brand-hover',
        'accent-selected', 'accent-on-selected',
        'border-subtle', 'border-control',
        'success', 'success-bg', 'warning', 'warning-bg', 'danger', 'danger-bg', 'info', 'info-bg',
        'focus',
      ],
    },
    classGroups: {
      'font-size': [{ text: ['meta', 'body', 'body-lg', 'section', 'title'] }],
      rounded: [{ rounded: ['control', 'menu', 'card', 'dialog', 'pill'] }],
      shadow: [{ shadow: ['card', 'overlay'] }],
    },
  },
});

export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

/** Shared focus-visible ring classes (outline, never border-only). */
export const focusRing = 'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-focus';
